import { spaceCadet } from '@cogneed/react-utils';
import { ChevronRight } from '@mui/icons-material';
import {
  Badge,
  Divider,
  ListItemButton, ListItemText,
} from '@mui/material';
import Typography from '@mui/material/Typography';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { DisplayType } from '../../../../../../../../../generated/core-api/graphql-react-query';
import useTimeAgo from '../../../../../../../../../Hooks/useTimeAgo';
import useTimedHighlight from '../../../../../../../../Hooks/useTimedHighlight';
import { LatestDetection } from '../../../../../../../../LiveContext/SessionContext/SessionDetectionContextProvider/useSessionDetectionContext';
import useSessionContext from '../../../../../../../../LiveContext/SessionContextProvider/useSessionContext';
import { DetectionGroup } from '../../../../../../Contexts/DetectionGroupContext';
import DetectionLine from './Components/DetectionListItem';
import StyledListItem from './styles';

function DetectionGroupMore(props: { detection: LatestDetection & { cardTitle: string, commandTitle: string } }) {
  const { t } = useTranslation();
  const { detection } = props;
  const timeAgo = useTimeAgo(detection.date);
  return (
    <Typography variant="h4" style={{ fontSize: 9 }}>
      {t('detections.more', { timeAgo })}
    </Typography>
  );
}

function DetectionGroupSecondary(props: { detectionGroup: DetectionGroup, index: number }) {
  const { detectionGroup, index } = props;
  const isHighlighted = useTimedHighlight(detectionGroup.detections[0].date) && index === 0;
  return (
    <>
      {detectionGroup.detections.slice(0, 3).map((detection, detectionIndex) => <DetectionLine key={detection.id} detection={detection} isHighlighted={isHighlighted && detectionIndex === 0} />)}
      {detectionGroup.detections.length > 3 && <DetectionGroupMore detection={detectionGroup.detections[3]} />}
    </>
  );
}

interface DetectionGroupListItemProps {
  detectionGroup: DetectionGroup;
  index: number;
}

function UpdateBadge(props: { children: React.ReactNode, notificationBadge: { seen: boolean } | undefined }) {
  const {
    children, notificationBadge,
  } = props;

  if (!notificationBadge) {
    // eslint-disable-next-line react/jsx-no-useless-fragment
    return <>{children}</>;
  }

  if (notificationBadge.seen) {
    return (
      <Badge color="secondary" variant="dot" anchorOrigin={{ horizontal: 'left', vertical: 'top' }}>
        {children}
      </Badge>
    );
  }
  return (
    <Badge color="error" variant="dot" anchorOrigin={{ horizontal: 'left', vertical: 'top' }}>
      {children}
    </Badge>

  );
}

export default function DetectionGroupListItem(props: DetectionGroupListItemProps) {
  const { detectionGroup, index } = props;
  const navigate = useNavigate();
  const { pinnedAt, pin } = useSessionContext();
  function onClick() {
    if (!pinnedAt) {
      pin?.();
    }
    navigate(`/projects/${detectionGroup.projectId}/cards/${detectionGroup.id}?displayType=${DisplayType.History}`);
  }
  return (
    <StyledListItem disablePadding>
      {index !== 0 && <Divider style={{ marginBottom: 8 }} />}
      <ListItemButton onClick={() => { onClick(); }}>
        <ListItemText
          primary={(
            <div className="detectionGroupTitle">
              <UpdateBadge notificationBadge={detectionGroup.notificationBadge}>
                <Typography variant="h4" noWrap>{detectionGroup.title}</Typography>
              </UpdateBadge>
              <ChevronRight style={{ color: spaceCadet[400], fontSize: 16 }} />
            </div>
          )}
          secondary={<DetectionGroupSecondary detectionGroup={detectionGroup} index={index} />}
          secondaryTypographyProps={{ component: 'div' }}
        />
      </ListItemButton>
    </StyledListItem>
  );
}
